import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  helmet: '',
  desc: 'RTLS(Real-time Location Systems)란 실시간 위치 추적 시스템으로, 무선 통신, RFID, GPS, BLE, UWB 등 다양한 기술을 활용하여 개발된 위치 추적 기술입니다.',
  keywords: 'RTLS, 위치추적, 실내위치추적, UWB, BLE, GPS, RFID, SmartDevice, 건설현장, 안전관리, 의료장비추적, 물류추적, 자산관리, 방문객추적, 방문객관리',

  ogTitle: '',
  ogDesc: '',
  ogSite: '실시간 위치추적 시스템(RTLS)란? :: ORBRO 블로그',
  ogUrl: 'https://orbro.io/blog/rtls',
  ogKey: '',
  ogImg:
    'https://lh3.googleusercontent.com/fife/APg5EOa-nRYXA8PZImoRPlC90eAt55C_Yy5HojqGpcHjostLqtAF14MCSQ278cDyuN65UTXHiZHKvWeZoTRbQjbqQfGXnKhLe0Jzybk5GEEeDIBPuaQ2yJMVTE7cYE4ybvDVweuPcGID5jW-Km3DtdqhciBpUOpej1uGnUdDTETQFhnYEqhziXT9YHAFI273KfzuCNJ_uUqla7WVrXuO-L-JB9VOb02pjgn9OBX7ABY94YhcQuq6a-Ab-nBcHbSmBNGXO1A8mMU-tX8hUz0u8674fbuG1dG0s39XddJNEeATt4PPsUeHudjCnqM1mN5HYXmvKTbQDEwzHBUET0GnnPpP4qVOG863atiB02qL8oopfM9EARdQjyJvxwLzBI1I9gkPm8wG4--IG7ViMVK4wRq79qmHgONSyFMJoqVcMChZeB701Ly6tordATCjgSlwZmG4O0I9W-G0ngTMbYP3AFihY2RPoQic3cTW_4jhftk7gMEPACbeZIh6jokwFH2KqMxpAVFKgew8f6Xr5lEiMx1C32laNCJfgRS6Xcnp4Oz68hKxcpR_Fn2nHamfrquJVPM7rKuEcnfndeSOs3wrBpMk-FMkx3hgt1QqB4LW0OLmWNWl5ps3dhN2NItej8os9Zeh_2wcCMnFaM_hbDj-UrbDNl7QDg_oGk9Etqxc2xrfS1yM5uMP78VIHwgPqrsHx6RqMEtgLZFjVCRBhr_n61ELA0YFi3gN-ybLRz3qBXMpkAq9iGl79fwmZuKwVEMnOvMPMsGpxAwM-c2O_WDEF4Ux-6lUxX7d9BGAPDPSwRvcwfF8rfLhEnz_wpeT-Os5mApgdVujb0fYri1b7J9ghi54_nZCyDPci8vn-GpyhH0k6Y4b_g_m723hFbaw1OfNPXx1uc-riT8pR82xvGhJ_EtOPsWIXtaEtiljYneEBpDa24VRkJt5afbOwE99dwRbNKrrlPJc-uZBNlNy9NsH8_2tYFjt1fi2WO6DmDukQqiW3eiYKAY8rINaMN4i38u5wJT1AVlykMVMcqtcugjpg3MBh066wvi5rSKgh-P-2H7qVk58IrARg3z24QXHaA4KPkicsJEFI5I11-x0daCC5h3lo0BV-grpGI7fGDWd_eOyj76t509E6BIPpx6DQ3B_TawRKRHGCRXdagn5iJy66zrQfuaHi78tKYqs_N8Noa8_Un3XstK2nD_Y86r-SmsLonEhHAZFoCJ-yv3YbRA_fVz1QIDIxBNdfifkvLjy6SlgtRb84_XzUPKjcMBalkMWrjzOSWYvShQ8OHTopeZK1HJdDLBzbdi2a7sTKpULhRBcWWDzLkgDrdgQHPsc_gkq9ZnisEl3GNOElWsbItVNyDdeXriH5YdSibObkZStczC8FKOdKf1urhaY95eEUrEgFKtTDL44ZXtLgM7KbxUrLqXmp8_ZZT-IPBJss-j3ydlHfcbCQ2Vr0eXK_Alu4os65IyR3hgGYmYcmtci14dWMSKJjZmyQ6LqBV9bwNmfQxcm2CqnImGEdAVbfpHuy1tcwaJ4aZq8X6K4q-7Np--NMO-2u-ULgFP8OfGDSLgEvAfn5JOyig=w2059-h1216',
  ogType: 'website',

  twitterCard: '',
  twitterTitle: '',
  twitterDesc: '',

  title: '실시간 위치추적 시스템(RTLS)란?',
  date: '2023-04-17',
  tag1: '#위치추적',
  tag2: '#RTLS',
  tag3: '#UWB',
  tag4: '#BLE',

  rtls: {
    title: 'RTLS 기술이란 무엇입니까?',
    desc: 'RTLS(Real-time Location Systems)란 실시간 위치 추적 시스템으로, 무선 통신, RFID(Radio Frequency Identification), GPS(Global Positioning System), BLE, UWB 등 다양한 기술을 활용하여 개발된 위치 추적 기술입니다. <br/><br/>RTLS 기술은 물체, 사람 등을 실시간으로 추적하며, 위치 정보를 수집하고 처리하여 이를 활용할 수 있습니다. 이를 통해 물류, 제조, 건설, 소매 등 다양한 산업 분야에서 보다 정확하고 효율적인 생산 관리와 물류 서비스를 제공할 수 있습니다. <br/><br/>RTLS 기술은 각 산업 분야별로 다양한 용도로 활용됩니다. 제조 분야에서는 생산 공정 내의 장비나 제품의 위치 추적, 물류 분야에서는 상품의 재고 관리 및 유통 추적, 건설 분야에서는 공사 현장에서의 안전관리, 장비 및 물자 추적 등이 가능합니다. RTLS 시스템은 회사가 고유한 공간에 배치되며 장거리에서 자산을 추적하기보다는 프로세스를 모니터링하고 개선하는 것을 목표로 합니다.<br/><br/>RTLS에는 세 가지 주요 요소가 있습니다.',
  },

  realtime: {
    title: '1. 실시간 추적',
    desc: 'RTLS 기술은 자산의 위치 정보를 실시간으로 파악하여, 해당 자산이 전체 수명주기 동안 어디에 위치해 있는지 더욱 정확하게 파악할 수 있게 해줍니다. 이는 제품 생산 라인에서 이동하는 제품, 공장 내부의 공구, 창고에 도착하는 원자재, 차량 위치, 직원 위치 등 거의 모든 것을 태그하고 추적할 수 있습니다. 이를 통해 기업은 자산 위치에 대한 더욱 체계적인 감시와 관리가 가능해져, 생산 라인 관리, 물류 서비스, 안전 관리 등 다양한 분야에서 효과적으로 활용할 수 있습니다.',
  },

  predict: {
    title: '2. 추세 및 예즉',
    desc: '자산의 위치와 움직임을 측정할 수 있게 된다면, 프로세스를 파악하여 쉽게 피할 수 있는 오류, 불필요한 단계, 자원의 부족, 직원의 비정상적인 행동 등을 더욱 쉽게 파악할 수 있습니다. 이를 통해 생산 라인, 물류, 안전 관리 등 다양한 분야에서 일어날 수 있는 문제점을 조기에 파악하여 더욱 효과적인 관리가 가능해집니다.',
  },

  geo: {
    title: '3. 지오 펜싱',
    desc: '3차원 공간에서 가상 경계를 정의하는 것은, 직원의 안전 지키기, 오염 방지, 보안 등 다양한 분야에서 활용됩니다. 이를 통해 위험 지역으로부터 직원을 보호하고, 오염을 방지하며, 보안을 강화하는 등의 다양한 적용 분야가 있습니다.',
  },

  howItWorks: 'RTLS는 어떻게 동작하나요 ?',

  core: {
    title: '핵심 구성 요소',
    desc: 'RTLS 시스템은 모두 송신기, 수신기, 데이터를 통합하고 위치를 분석하는 소프트웨어 이렇게 세 가지 요소로 구성됩니다. 각 RTLS 제공업체는 그들의 기술에 대해 조금씩 다른 용어를 사용하며, 그들의 고유한 판매 포인트에 중점을 둘 것입니다. 아래는 이러한 핵심 시스템 구성 요소를 일반화한 것입니다.',
  },

  send: {
    title: '송신기',
    desc: 'RTLS에서 송신기란 주로 태그 또는 수신기와 연결되어 있는 기기를 말합니다. 이 기기는 물체나 개인을 식별하고 위치 정보를 수신기로 전송합니다. 송신기는 일반적으로 무선 기술을 사용하여 작동하며, 기술에 따라 크기와 성능이 다양합니다. 송신기는 물체에 부착될 수도 있고, 개인이나 동물에게 착용될 수도 있습니다. 일부 기종은 전원이 필요 없는 "passive" 송신기를 사용하며, 이러한 송신기는 근거리 RFID 기술을 사용합니다. 다른 기종에서는 전원이 필요한 "active" 송신기를 사용하며, 이러한 송신기는 일반적으로 블루투스 저에너지(BLE)나 Ultra-Wideband (UWB)와 같은 무선 기술을 사용합니다. 또한, GPS 태그도 송신기로 사용될 수 있습니다.',
  },

  rfid: {
    title: '1.RFID Tags',
    desc: '가장 일반적인 태그 중 하나로, 패시브(즉, 배터리 전원이 필요하지 않은)로 동작하며 거의 모든 물건에 부착하여 자산을 식별하는 데 사용됩니다.',
  },

  ble: {
    title: '2.BLE Tags',
    desc: '가장 보편화된 무선통신 중 하나인 BLE 신호를 발신하는 송신기 이다. 대부분의 Mobile 기기에서도 동작하기 때문에 범용성이 넓지만 UWB보다는 정확도가 낮습니다.',
  },

  uwb: {
    title: '3. UWB Tags',
    desc: '일반적으로 배터리 전원이 필요한 UWB 신호를 발신하며 UWB 수신기에서 수신합니다. 신호는 매우 짧지만 광대역 주파수 대역을 사용하여 저전력 소모로 매우 정확한 위치 데이터를 제공합니다.',
  },

  smart: {
    title: '4. Smart Devices',
    desc: '다양한 스마트 디바이스가 송신기로 작동할 수 있으며, 휴대전화가 가장 대표적인 예입니다. BLE와 GPS 방식을 모두 사용할 수 있으며 최근 UWB가 보급되어감에 따라 일부 기종에서 UWB를 이용한 추적을 지원합니다.',
  },

  gps: {
    title: '5. GPS Tags',
    desc: 'GPS 태그는 위성을 사용하여 위치를 파악합니다. 하지만 가시성이 좋은 실외 환경에서만 작동하며 추가 인프라가 필요하지 않습니다. GPS 태그는 UWB 태그보다 정확도가 낮고 전력 소모가 상대적으로 많습니다. 그러나 리얼타임 키네마틱 GPS를 추가하여 메인 GPS 신호를 보정하여 정확도를 센티미터 단위로 향상시킬 수 있습니다.',
  },

  receive: {
    title: '수신기',
    desc: '사용하는 태그의 종류에 따라, 태그를 추적하기 위해 사용되는 수신기는 다양합니다. 단순한 패시브 RFID 태그로는 충분하지 않은 더 복잡한 실내 환경에서는 액티브 RFID, Bluetooth Low Energy(BLE) 또는 Ultra-Wideband(UWB) 기술을 사용할 수 있습니다. <br/><br/> 중요한 자산에 태그를 부착하고 물리적 공간(공장, 비행기 헬기 창고, 사무실 등) 주변에 수신기를 배치함으로써, 수신기는 언제든지 각 자산의 위치를 결정하고 이 정보를 관련 소프트웨어/시각화 시스템으로 전달할 수 있습니다. 이러한 수신기는 일반적으로 전원 공급원과 네트워크(유선 또는 무선으로)에 직접 연결됩니다.',
  },

  software: {
    title: 'Software',
    desc: 'RTLS 기술에는 센서와 태그 같은 하드웨어에서 실행되는 펌웨어와 위치데이터를 해석하는 외부 어플리케이션, 그리고 외부 어플리케이션에 연결하는 미들웨어를 포함한 여러 가지로 구성된 소프트웨어 시스템이 사용됩니다. 즉, 이러한 소프트웨어들이 함께 작동하여 RTLS 시스템이 동작하게 됩니다. <br/><br/> 그 중에서 RTLS 기술을 활용하려는 기업들에게 가장 관심이 있는 것은 외부 애플리케이션의 소프트웨어입니다. 이 소프트웨어는 RTLS와 상호작용하고 이로부터 이익을 얻는 방법을 결정합니다. 어느 산업에 속하느냐에 따라, 애플리케이션 소프트웨어는 크게 달라질 수 있습니다. 많은 RTLS 기업들은 기업의 전반적인 개요를 최적화하고 쉬운 인사이트를 제공하기 위해 설계된 맞춤형 소프트웨어 애플리케이션을 제공합니다. <br/><br/>  RTLS 시스템에서 시각화는 보통 핵심적인 역할을 담당하며, RTLS 소프트웨어 솔루션을 선택할 때 고려해야 할 요소로는 다음과 같은 것들이 있습니다. <br/><br/> 평면도와 영역 맵핑 - 소프트웨어가 실제 평면도를 정확하고 축적도니 크기로 반영할 수 있는가 ? <br/> 소프트웨어의 실용성 - 멋진 시각화와 더불어, 사용자의 목적에 맞는 필수적인 기능을 포함하고 있는가 ? <br/> 품질 보고서 - 즉시 인사이트를 얻기 위한 분석 및 보고 기능이 존재 하는가 ? <br/> 온프레미스 또는 클라우드 - 가장 적합한 방법으로 소프트웨어를 호스팅할 옵션이 있는가 ? <br/> API 연결 - 소프트웨어가 API를 통해 기존의 비즈니스 시스템 및 데이터베이스와 연결할 수 있는가 ? <br/> 확장성 - 이 소프트웨어는 비즈니스가 성장함에 따라 확장할 수 있으며, 위치 데이터 스트림이 수집되는 동안 병목 현상 없이 작동하는 것이 입증되었는가?​ <br/>지원 및 교육 - 이 솔루션을 시작하는 데 얼마나 간단한가, 그리고 중요한 미션을 담당하는 애플리케이션에 대한 지원이 잘 되는가 ?',
  },

  conclusion: {
    title: 'RTLS 기술의 사용 사례는 무엇 입니까?',
    desc: 'RTLS 기술에 대한 인식이 높아지면서, 이 기술을 적용할 수 있는 산업이 점점 더 명확해지고 있습니다. 대표적인 예시는 아래와 같습니다.',
  },

  advantage: {
    safety: {
      title: '건설현장 안전 관리',
      desc: '작업자와 건설 장비, 재료의 위치와 이동 경로를 실시간으로 추적하여 위험 구역이나 행동을 감지하고, 작업자에게 경고를 보내어 사고를 예방합니다.',
    },
    assets: {
      title: '물류창고 자산 추적',
      desc: '위치 추적 기술은 자산의 위치를 실시간으로 파악할 수 있어, 작업자가 자산의 위치를 찾는 데 걸리는 시간고 노력을 줄일 수 있습니다. 이는 작업 효율성을 향상시키며, 재고 이동 경로를 최적화하여 물류 프로세스의 효율성을 높이는 데에도 도움이 됩니다.',
    },
    medical: {
      title: '병원 의료 장비 및 환자 추적',
      desc: '위치 추적 기술은 자산의 위치를 실시간으로 파악할 수 있어, 작업자가 자산의 위치를 찾는 데 걸리는 시간고 노력을 줄일 수 있습니다. 이는 작업 효율성을 향상시키며, 재고 이동 경로를 최적화하여 물류 프로세스의 효율성을 높이는 데에도 도움이 됩니다.',
    },
    monitor: {
      title: '실시간 생산공정 모니터링',
      desc: '제조업체나 공장의 제품 생산 과정에서 제품의 위치, 생산 라인의 움직임, 작업자의 위치 등을 실시간으로 추적할 수 있도록 합니다. 실시간으로 위치 정보를 파악하여 생산 라인의 움직임이 원활하게 이루어지도록 도와주며, 공정에 문제가 발생했을 때 빠르게 대처할 수 있도록 도와줍니다. 이를 통해 공장의 생산 라인을 최적화하고, 제품 생산과정의 효율성을 높이며, 생산품질을 개선하는 데 큰 역할을 합니다.',
    },
    visitor: {
      title: '전시장 방문객 분석',
      desc: '박물관, 전시관, 리테일 매장 등에서 방문객의 시간대별 공감 점유율을 분석할 수 있습니다. 이를 통해 방문자의 이동 경로, 방문 빈도, 체류 시간, 인기 있는 전시물 등의 정보를 파악할 수 있으며, 이를 토대로 전시물이나 상품의 위치나 배치를 조정하여 방문객들의 만족도를 높이는데 활용합니다.',
    },

    label:
      'RTLS 기술은 자동차, 항공우주, 국방, 유지보수/수리/운영, 대중교통, 창고 및 물류, 의료 등 여러 산업에서 RTLS 기술을 활용하여 더 나은 효율성과 안전성을 추구하고 있습니다. RTLS 기술은 기업의 경쟁력을 강화하는 데 매우 중요합니다. RTLS를 사용하면 시간을 절약하고 노동력을 절감하며, 재고 관리 및 부품 추적 등을 보다 효율적으로 관리할 수 있습니다. 또한 RTLS는 작업자의 안전을 개선하고 위험 요소를 줄이는 데 도움이 됩니다 <br/><br/>RTLS 기술은 앞으로의 대부분의 산업 분야에서 높은 수준의 수익성과 효율성을 추구하는 기업들에게 필수적인 기술 중 하나입니다.',
  },

  share: '글이 마음에 드셨나요? <br/> 공유하기',

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
